import React from 'react';
import PropTypes from 'prop-types';

const People = ({ color = '#C70000', width = 7, height = 14 }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Group 482887">
<g id="Group">
<path id="Vector" d="M15.225 5.64343C13.9832 5.59844 12.9933 4.58156 12.9933 3.32172C12.9933 2.03487 14.0282 1 15.315 1C16.6018 1 17.6367 2.04387 17.6367 3.32172C17.6277 4.58156 16.6378 5.59844 15.396 5.64343C15.342 5.63443 15.279 5.63443 15.225 5.64343Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_2" d="M14.4691 12.1947C15.7019 12.4016 17.0608 12.1857 18.0146 11.5467C19.2835 10.7008 19.2835 9.31501 18.0146 8.46911C17.0518 7.83019 15.6749 7.61421 14.4421 7.83018" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
</g>
<g id="Group_2">
<path id="Vector_3" d="M4.74132 5.64343C5.98317 5.59844 6.97305 4.58156 6.97305 3.32172C6.97305 2.03487 5.93818 1 4.65134 1C3.36449 1 2.32962 2.04387 2.32962 3.32172C2.33862 4.58156 3.3285 5.59844 4.57035 5.64343C4.62434 5.63443 4.68733 5.63443 4.74132 5.64343Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_4" d="M5.49719 12.1947C4.26435 12.4016 2.90551 12.1857 1.95163 11.5467C0.682789 10.7008 0.682789 9.31501 1.95163 8.46911C2.91451 7.83019 4.29134 7.61421 5.52419 7.83018" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
</g>
<g id="Group_3">
<path id="Vector_5" d="M9.82567 12.3656C8.58383 12.3206 7.59395 11.3037 7.59395 10.0439C7.59395 8.75701 8.62882 7.72214 9.91566 7.72214C11.2025 7.72214 12.2374 8.76601 12.2374 10.0439C12.2284 11.3037 11.2385 12.3296 9.99665 12.3656C9.94266 12.3566 9.87967 12.3566 9.82567 12.3656Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_6" d="M7.37799 18.2779C8.81781 19.2407 11.1755 19.2407 12.6153 18.2779C13.8842 17.432 13.8842 16.0461 12.6153 15.2002C11.1845 14.2464 8.81781 14.2464 7.37799 15.2002C6.10914 16.0461 6.10914 17.432 7.37799 18.2779Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
</g>
</g>
</svg>
);

People.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default People; 
